import tippy from 'tippy.js';

tippy('[data-tippy-content]');


tippy('[data-tippy-content-html]', {
  content(reference) {
    const template = reference.parentNode.querySelector('.tippy-content-html')

    return template.innerHTML;
  },
  allowHTML: true,
});
